import { render, staticRenderFns } from "./RelatedAbout.vue?vue&type=template&id=a3f55d48&scoped=true&"
import script from "./RelatedAbout.vue?vue&type=script&lang=js&"
export * from "./RelatedAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f55d48",
  null
  
)

export default component.exports